import { combineReducers } from '@reduxjs/toolkit';
import { reducer as allAbsenceReducer } from './model/absence';

export * as AbsenceModel from './model';

const absenceReducer = combineReducers({
  absence: allAbsenceReducer,
});

export default absenceReducer;
